import React from "react";
import { FormattedMessage } from "react-intl";
import Dropdown from "@components/Dropdown/dropdown";
import locales from "@translations/locales";
import { changeLanguage } from "@translations/i18n";
import UniplacesLogo from "@assets/images/svgs/uniplaces-logo.svg";
import styles from "../header.module.scss";

const HOW_IT_WORKS_KEY = 'how_it_works';
const localesValues = Object.values(locales);

const HeaderDesktop = ({ headerItems, locale }) => {
  const onChangeLanguage = (lang) => {
    const localeObj = locales[lang];
    changeLanguage(localeObj.path, localeObj.default);
  };

  return (
    <header className={styles.header}>
      <a href={process.env.HOMEPAGE_URL} key="logo" aria-label="Homepage">
        <UniplacesLogo />
      </a>
      <ul className={styles.header__list}>
        {
          headerItems.map(({ key, href }) => (
            <li key={key} className={styles.header__list__items}>
              <a href={key === HOW_IT_WORKS_KEY ? href[locale] : href}>
                <FormattedMessage id={`header.${key}`} />
              </a>
            </li>
          ))
        }
      </ul>
      <div className={styles.separator} />
      <Dropdown
        defaultValue={locale}
        onChange={onChangeLanguage}
        values={localesValues}
      />
    </header>
  );
}

export default HeaderDesktop;
